import { appServiceClient } from '@/infrastructure/http/httpClient';

import {
  CargaCapacidade,
  ConfiabilidadePrazo,
  EvolucaoCarteira,
  EvolucaoCarteiraQuery,
  IndicadoresRelatorio,
  IParqueDeMaquinasRelatorio,
  IPessoasPorCelulaRelatorio,
  MudancasCarteiraRelatorio,
} from '../interfaces/relatorios';

function buildQs(query: EvolucaoCarteiraQuery): string {
  const params = new URLSearchParams();
  if (query.inicio !== undefined && query.inicio !== '') {
    params.set('inicio', query.inicio);
  }
  if (query.fim !== undefined && query.fim !== '') {
    params.set('fim', query.fim);
  }
  const qs = params.toString();
  return qs !== '' ? `?${qs}` : '';
}

class RelatoriosRepository {
  /** Omitting the dates lets the API resolve its default window and echo it back. */
  async evolucaoCarteira(query: EvolucaoCarteiraQuery = {}): Promise<EvolucaoCarteira> {
    return appServiceClient.get<EvolucaoCarteira>(`relatorios/carteira/evolucao${buildQs(query)}`);
  }

  /**
   * Omitting the day lets the API compare today in the factory timezone, and omitting
   * `base` compares against the previous snapshot. Both filled, the screen picked the
   * two ends, which do not have to be consecutive days.
   */
  async mudancasCarteira(dia?: string, base?: string): Promise<MudancasCarteiraRelatorio> {
    const params = new URLSearchParams();
    if (dia !== undefined && dia !== '') {
      params.set('dia', dia);
    }
    if (base !== undefined && base !== '') {
      params.set('base', base);
    }
    const qs = params.toString();
    return appServiceClient.get<MudancasCarteiraRelatorio>(
      `relatorios/carteira/mudancas${qs === '' ? '' : `?${qs}`}`,
    );
  }

  async cargaCapacidade(semanas: number): Promise<CargaCapacidade> {
    return appServiceClient.get<CargaCapacidade>(`relatorios/carga-capacidade?semanas=${semanas}`);
  }

  /** The three PRD indicators in ONE call: the screen never fans out. */
  /** Um retrato de quem esta em cada celula. Sem periodo: e o cadastro de agora. */
  async pessoasPorCelula(): Promise<IPessoasPorCelulaRelatorio> {
    return appServiceClient.get<IPessoasPorCelulaRelatorio>('relatorios/pessoas-por-celula');
  }

  async parqueDeMaquinas(): Promise<IParqueDeMaquinasRelatorio> {
    return appServiceClient.get<IParqueDeMaquinasRelatorio>('relatorios/parque-maquinas');
  }

  async indicadores(query: EvolucaoCarteiraQuery = {}): Promise<IndicadoresRelatorio> {
    return appServiceClient.get<IndicadoresRelatorio>(`relatorios/indicadores${buildQs(query)}`);
  }

  async confiabilidadePrazo(query: EvolucaoCarteiraQuery = {}): Promise<ConfiabilidadePrazo> {
    return appServiceClient.get<ConfiabilidadePrazo>(`relatorios/confiabilidade-prazo${buildQs(query)}`);
  }
}

export const relatoriosRepository = new RelatoriosRepository();
